import { Grid, Typography } from "@mui/material";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";

const AppaointmentStatus = ({
  appointment,
}: {
  appointment: IDayliPlanAppointment;
}): React.JSX.Element => {
  const translateStatus = (status: string) => {
    switch (status) {
      case "G":
        return "Gebucht";
      case "V":
        return "Versäumt";
      case "K":
        return "Kulanzstorniert";
      default:
        return "Unbekannt";
    }
  };

  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={3}
      lg={2}
      sx={{
        mb: 2,
      }}
    >
      <Typography
        sx={{
          fontWeight: "bold",
        }}
        variant="caption"
        component="p"
      >
        Staus
      </Typography>
      <Typography variant="body1" component="p">
        {translateStatus(appointment.status)}
      </Typography>
    </Grid>
  );
};

export default AppaointmentStatus;
